import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export const PLATFORM_LINKS = {
  spotify: "https://open.spotify.com/show/3G2R1poGOvQXxiGzHonE48",
  youtube: "https://youtube.com/@jesus-talk-",
  apple: "https://podcasts.apple.com/", // à personnaliser
  deezer: "https://www.deezer.com/", // à personnaliser
  rss: "https://anchor.fm/s/ebc9d1c8/podcast/rss",
  whatsapp: "https://whatsapp.com/channel/0029VbDK7iY60eBeqPafye31",
  instagram: "https://www.instagram.com/jesus___talk",
};
